const BASE = '/api';

function getToken() { return localStorage.getItem('hd_token'); }

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (getToken()) headers['Authorization'] = `Bearer ${getToken()}`;
  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${res.status}`);
  }
  return res.status === 204 ? null : res.json();
}

export const api = {
  login:          (body)     => request('/auth/login', { method:'POST', body: JSON.stringify(body) }),
  me:             ()         => request('/auth/me'),
  createTicket:   (body)     => request('/tickets', { method:'POST', body: JSON.stringify(body) }),
  getTickets:     (q='')     => request(`/tickets${q}`),
  getTicket:      (id)       => request(`/tickets/${id}`),
  deleteTicket:   (id)       => request(`/tickets/${id}`, { method:'DELETE' }),
  updateTicket:   (id, body) => request(`/tickets/${id}`, { method:'PUT', body: JSON.stringify(body) }),
  getStats:       ()         => request('/tickets/stats'),
  getComments:    (id)       => request(`/tickets/${id}/comments`),
  addComment:     (id, body) => request(`/tickets/${id}/comments`, { method:'POST', body: JSON.stringify(body) }),
  escalate:       (body)     => request('/escalation', { method:'POST', body: JSON.stringify(body) }),
  getAttachments: (ticketId) => request(`/tickets/${ticketId}/attachments`),
  uploadAttachments: (ticketId, formData) => {
    const token = localStorage.getItem('hd_token');
    return fetch(`/api/tickets/${ticketId}/attachments`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    }).then(r => r.json());
  },
  getAgents:           ()         => request('/agents'),
  getSurveyResults:    ()         => request('/survey/results'),
  getDepartments:      ()         => request('/departments'),
  createDepartment:    (body)     => request('/departments', { method:'POST', body: JSON.stringify(body) }),
  updateDepartment:    (id, body) => request(`/departments/${id}`, { method:'PUT', body: JSON.stringify(body) }),
  deleteDepartment:    (id)       => request(`/departments/${id}`, { method:'DELETE' }),
  getEvents:    (from, to) => request(`/events?from=${from}&to=${to}`),
  createEvent:  (body)     => request('/events', { method:'POST', body: JSON.stringify(body) }),
  updateEvent:  (id, body) => request(`/events/${id}`, { method:'PUT', body: JSON.stringify(body) }),
  deleteEvent:  (id)       => request(`/events/${id}`, { method:'DELETE' }),

  // ── Extensiones (directorio telefónico) ──────────────────────────────────
  getExtensions:    ()         => request('/extensions'),
  getExtSections:   ()         => request('/extensions/sections'),
  createExtSection: (body)     => request('/extensions/sections', { method:'POST', body: JSON.stringify(body) }),
  updateExtSection: (id, body) => request(`/extensions/sections/${id}`, { method:'PUT', body: JSON.stringify(body) }),
  deleteExtSection: (id)       => request(`/extensions/sections/${id}`, { method:'DELETE' }),
  createExtContact: (sectionId, body) => request(`/extensions/sections/${sectionId}/contacts`, { method:'POST', body: JSON.stringify(body) }),
  updateExtContact: (id, body) => request(`/extensions/contacts/${id}`, { method:'PUT', body: JSON.stringify(body) }),
  deleteExtContact: (id)       => request(`/extensions/contacts/${id}`, { method:'DELETE' }),
  reorderExtSections: (order)  => request('/extensions/sections/reorder', { method:'PUT', body: JSON.stringify({ order }) }),
  reorderExtContacts: (order)  => request('/extensions/contacts/reorder', { method:'PUT', body: JSON.stringify({ order }) }),
  getExtPhones:     ()         => request('/extensions/phones'),
  getExtBlocked:    ()         => request('/extensions/blocked'),
  addExtBlocked:    (body)     => request('/extensions/blocked', { method:'POST', body: JSON.stringify(body) }),
  removeExtBlocked: (id)       => request(`/extensions/blocked/${id}`, { method:'DELETE' }),
  getExtFree:       (count=10) => request(`/extensions/free?count=${count}`),

  // ── Préstamos de equipos ──────────────────────────────────────────────
  getEquipmentPublic:  ()         => request('/loans/equipment/public'),
  getEquipment:        (q='')     => request(`/loans/equipment${q}`),
  getEquipmentItem:    (id)       => request(`/loans/equipment/${id}`),
  createEquipment:     (body)     => request('/loans/equipment', { method:'POST', body: JSON.stringify(body), headers:{'Content-Type':'application/json'} }),
  updateEquipment:     (id,body)  => request(`/loans/equipment/${id}`, { method:'PUT', body: JSON.stringify(body), headers:{'Content-Type':'application/json'} }),
  deleteEquipment:     (id)       => request(`/loans/equipment/${id}`, { method:'DELETE' }),
  getLoans:            (q='')     => request(`/loans${q}`),
  getLoan:             (id)       => request(`/loans/${id}`),
  updateLoan:          (id,body)  => request(`/loans/${id}`, { method:'PUT', body: JSON.stringify(body), headers:{'Content-Type':'application/json'} }),
  returnLoan:          (id)       => request(`/loans/${id}/return`, { method:'POST' }),
  getLoanStats:        ()         => request('/loans/stats'),
  createLoanRequest:   (body)     => request('/loans/requests', { method:'POST', body: JSON.stringify(body), headers:{'Content-Type':'application/json'} }),

  // ── Reservas de espacios ─────────────────────────────────────────────
  getRooms:           ()         => request('/rooms'),
  getRoomCategories:  ()         => request('/rooms/categories'),
  getRoomLocations:   ()         => request('/rooms/locations'),
};
